import styled from "@emotion/styled";

export const ToolCallDetails = styled.details`
  font-size: 0.8rem;
  color: var(--color-charcoal-60, rgba(33, 33, 33, 0.6));
  margin-bottom: 0.25rem;

  &[open] > summary {
    margin-bottom: 0.25rem;
  }
`;

export const ToolCallSummary = styled.summary`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  user-select: none;
  list-style: none;

  &::-webkit-details-marker {
    display: none;
  }

  &::before {
    content: "\\25B6";
    font-size: 0.55rem;
    transition: transform 0.15s ease;
  }

  details[open] > &::before {
    transform: rotate(90deg);
  }
`;

export const ToolCallBlock = styled.div`
  margin-top: 0.35rem;

  & + & {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid var(--color-charcoal-10, #e5e5e5);
  }
`;

export const ToolCallBlockLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: var(--color-charcoal-40, #999);
  margin-bottom: 0.25rem;
`;

export const ToolCallPre = styled.pre`
  font-size: 0.75rem;
  background: var(--color-fog, #f5f5f5);
  border-radius: 0.25rem;
  padding: 0.5rem;
  max-height: 200px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
`;

export const ToolCallResponseScroll = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;

export const ToolCallDocChunk = styled.details`
  &:not(:last-child) {
    margin-bottom: 0.35rem;
  }

  &[open] > summary {
    margin-bottom: 0.25rem;
  }
`;

export const ToolCallDocTitle = styled.summary`
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--color-charcoal-60, rgba(33, 33, 33, 0.6));
  cursor: pointer;
  user-select: none;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.3rem;

  &::-webkit-details-marker {
    display: none;
  }

  &::before {
    content: "\\25B6";
    font-size: 0.45rem;
    transition: transform 0.15s ease;
  }

  details[open] > &::before {
    transform: rotate(90deg);
  }
`;

export const ToolCallSpinner = styled.span`
  display: inline-block;
  width: 0.7rem;
  height: 0.7rem;
  border: 1.5px solid var(--color-charcoal-30, #ccc);
  border-top-color: var(--color-charcoal-60, #666);
  border-radius: 50%;
  animation: tool-call-spin 0.6s linear infinite;

  @keyframes tool-call-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
